import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Radiobox Marked"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-radiobox-marked',
    templateUrl: './icon-radiobox-marked.component.html',
    styleUrls: ['./icon-radiobox-marked.component.scss'],
    standalone: false
})
export class IconRadioboxMarkedComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
